import type { HttpClient } from '~/shared/api'
import { ApiService } from '~/shared/api'
import { CareerRoutesDetailModel } from '~/models/career-routes'
import { unwrapObject } from '~/shared/utils/response'
import { CareerRoutesCategoryService } from './CareerRoutesCategoryService'

export class CareerRoutesService extends ApiService {
  protected route: string = '/api/v1/yavagro/career-routes/list/query'
  protected itemRoute: string = '/api/v1/yavagro/career-routes'
  categoriesService: CareerRoutesCategoryService

  constructor(http: HttpClient) {
    super(http)
    this.categoriesService = new CareerRoutesCategoryService(http)
  }

  public async getList(params?: Record<string, string | number>): Promise<{ data?: unknown }> {
    const res = await this.http.request<{ data?: unknown }>({
      url: this.route,
      params,
    })

    return res.data
  }

  public async getItem(slug: string): Promise<CareerRoutesDetailModel> {
    const res = await this.http.request({
      url: `${this.itemRoute}/${slug}`,
    })

    return new CareerRoutesDetailModel(unwrapObject(res.data))
  }
}
